export const BlightEvents = {
  blightCalculationStatusUpdated: 'Arable_BlightCalculationStatusUpdated',
};

export interface BlightSyncStatusUpdatedEvent {
  CustomerId: number;
  CropFieldId: number;
  Status: 'Initiated' | 'Completed' | 'Failed';
  CalculationTaskCode: string;
  Timestamp: Date;
}
